import { configureStore } from "@reduxjs/toolkit";
import selectedTableReducer from "./slices/selectedTableSlice";
import csrDataReducer from "./slices/csrDataSlice";
import patientNarrativeReducer from "./slices/patientNarrativeSlice";
import scsDataReducer from "./slices/scsDataSlice";

export const store = configureStore({
  reducer: {
    selectedTable: selectedTableReducer,
    csrData: csrDataReducer,
    patientNarrative: patientNarrativeReducer,
    scsData: scsDataReducer,
  },
  devTools: true,
});
